import { render, staticRenderFns } from "./RiwayatInbound.vue?vue&type=template&id=39cbdbb6&scoped=true&"
import script from "./RiwayatInbound.vue?vue&type=script&lang=js&"
export * from "./RiwayatInbound.vue?vue&type=script&lang=js&"
import style0 from "./RiwayatInbound.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RiwayatInbound.vue?vue&type=style&index=1&id=39cbdbb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cbdbb6",
  null
  
)

export default component.exports